<template>
	<div class="message-bubble ">
		<div>
			<v-card>
				<v-card-title primary-title>
					Preguntas frecuentes
				</v-card-title>
				<v-card-text>
					<v-expansion-panels>
						<v-expansion-panel v-for="(f, index) in faqs" :key="index">
							<v-expansion-panel-header>
								{{ f.question }}
							</v-expansion-panel-header>
							<v-expansion-panel-content class="faq-answer">
								{{ f.answer }}
							</v-expansion-panel-content>
						</v-expansion-panel>
					</v-expansion-panels>
				</v-card-text>
				<v-card-actions>
					<BackBtn :return_to="'init'" :text="true" />
				</v-card-actions>
			</v-card>
		</div>
	</div>
</template>

<script>
import BackBtn from "./BackBtn";
export default {
	components: {
		BackBtn,
	},
	computed: {
		faqs: {
			get() {
				return this.$store.getters["chatStore/get_faqs"];
			},
		},
	},
};
</script>

<style lang="scss" scoped>
.bot-faq-return {
	padding: 5px;
}
.faq-answer {
	padding-top: 10px;
}
</style>
